module.exports = __webpack_public_path__ + "static/media/BZ.a4b52ad2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/BZ.svg
// module id = 2123
// module chunks = 7